export default __webpack_public_path__ + "static/media/Flag_of_European_Union.5a719884.svg";